
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upsc-setu-scholarship-test",
      function () {
        return require("private-next-pages/upsc-setu-scholarship-test/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upsc-setu-scholarship-test"])
      });
    }
  